import { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

import Home from './views/Home';
import Settings from './views/Settings';
import Accounts from './views/Accounts';
import RequestService from './views/RequestService';
import OpenAnAccount from './views/OpenAnAccount';

// import useDebounce from "./hooks/useDebounce";
import { onChangeSection } from './utils/NativeWebView';

import { useAppDispatch } from './hooks';

const AnimatedRoutes = () => {
  const location = useLocation();
  // const debouncedLocation = useDebounce<Location>(location, 500)
  // const navigate = useNavigate();

  const dispatch = useAppDispatch();

  // const redirectToHome = useCallback(
  //   (event: any) => {
  //     if (event?.data?.type === 'redirectWebToHome') {
  //       navigate('/');
  //     }
  //   },
  //   [navigate]
  // );

  useEffect(() => {

    function getLocationName(pathname:string): string {
      if (pathname==='/') {
        return 'home';
      } else {
        return pathname.substring(1);
      }
    }
    onChangeSection(getLocationName(location.pathname));

  }, [location, dispatch]);

  // useEffect(() => {
  //   window.addEventListener('message', redirectToHome);
  //   return () => window.removeEventListener('message', redirectToHome);
  // }, [redirectToHome]);

  return (
    <AnimatePresence exitBeforeEnter>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="accounts" element={<Accounts />} />
        <Route path="open-an-account" element={<OpenAnAccount />} />
        <Route path="services" element={<RequestService />} />
        <Route path="settings" element={<Settings />} />
      </Routes>
    </AnimatePresence>
  );
};
export default AnimatedRoutes;
